import { store } from '@betacrew/jars-flux'
import { PAGE_STATE } from '../../constants/constants';
export const componentKey = "SIGN_IN";

const initialSignInFormFields = {
    email : "",
    password: "",
    GRecaptchaResponse: ""
}

const { actions } = store.reducerManager.add({
    key: componentKey,
    addedReducers: {
        setSignInFormFields : (state, action) => {
            state.signInFormFields = {
                ...state.signInFormFields,
                ...action.payload,
            }
        },
        setShowError: (state, action) => {
            const {showError, errorMessage} = action.payload;
            state.showError = showError;
            state.errorMessage = errorMessage;
        },
        resetSignInPage: (state, action) => {
            state.signInFormFields = initialSignInFormFields;
        },
        setLoadingState: (state, action) => {
            state.loadingState = action.payload
        },
        setShowTFAScreen: (state, action) => {
            state.showTFAScreen = action.payload
        },
        setUserGoogleProfile: (state, action) => {
            state.userGoogleProfile = action.payload
        },
        setSignedInUserData : (state,action)=>{
            state.signedInUserData = action.payload
        }

    }, 
    initialReducerState: {
        signInFormFields : initialSignInFormFields,
        showError: false,
        errorMessage: "",
        showTFAScreen: false,
        loadingState: { state: PAGE_STATE.PAGE_READY, message: "" },
        userGoogleProfile: null,
        signedInUserData: {}
    }
});
export const { setSignInFormFields, setShowError, resetSignInPage, setLoadingState, setShowTFAScreen, setUserGoogleProfile, setSignedInUserData } = actions;